
// import RelatedPosts from "~/components/pages/articles/RelatedPosts";
import { mapGetters } from "vuex";
import UiBreadcrumbs from "~/components/UI/UiBreadcrumbs";
import { getImageByPosition, metaGenerator, normalizeI18nLinks } from "@/utils";
import jsonLdMixin from "~/mixins/jsonLdMixin";
import useEvents from "~/mixins/useEvents";
import ArticleListCard from "@/components/pages/articles/ArticleListCard.vue";

export default {
  components: {
    UiBreadcrumbs,
    ArticleListCard,
    // RelatedPosts
  },
  mixins: [jsonLdMixin, useEvents],
  async asyncData({ error, $api, params, store }) {
    const getNextPostBySlug = async () => {
      try {
        const { data } = await $api.blog.getNextPostBySlug(params.slug);
        return data?.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    };

    const getPostByType = async () => {
      try {
        const { data } = await $api.blog.getPostBySlug(params.slug);
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
        error({ statusCode: err.response.status });
      }
    };
    const article = await getPostByType();

    store.commit("general/SET_JSON_SCHEMA_DATA", {
      pageName: article?.mixedTranslation?.title,
      pageImage:
        getImageByPosition(article?.medias, "page")?.file?.url ||
        getImageByPosition(article?.medias, "list")?.file?.url,
      post: article,
    });
    return {
      article,
      nextPost: await getNextPostBySlug(),
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: true,
    });
    const jsonLdPayload = this.setBlogPostPageLdSchema();
    const titleTemplate = `%s | ${this.getCompanyName}`;

    // const mainCategory = this.article?.categories?.filter((el) => el.status)?.[0];
    // const canonicalPath = this.localePath(`/articles/${mainCategory?.slug || "all"}/${this.article?.slug}`);
    // const canonicalUrl = process.env.DOMAIN + canonicalPath;

    return {
      meta: [
        ...metaGenerator({
          title:
            this.article?.mixedTranslation?.meta_title ||
            this.article?.mixedTranslation?.title ||
            "",
          description: this.article?.mixedTranslation?.meta_description || "",
          image:
            this.article?.medias?.find((el) => el.position === "open-graph")
              ?.file?.url || "",
          keywords: this.article?.mixedTranslation?.meta_keywords || "",
          url:
            this.article?.mixedTranslation?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
          company_name: this.getCompanyName,
          titleTemplate,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: [
        ...normalizeI18nLinks(i18nHead.link),
        // {
        //   rel: "canonical",
        //   href: canonicalUrl,
        // },
      ],
      title:
        this.article?.mixedTranslation?.meta_title ||
        this.article?.mixedTranslation?.title ||
        "",
      titleTemplate,
      script: [
        {
          hid: this.getJsonLdScriptHid(jsonLdPayload),
          type: "application/ld+json",
          json: jsonLdPayload,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
    }),
    image() {
      return this.article?.medias?.find((el) => el.position === "page") || "";
    },
    articleCategory() {
      const activeArticleCategories = this.article?.categories?.filter((el) => el.status) || [];
      const currentCategory = activeArticleCategories?.find(
        (el) => el.slug === this.$route.params?.section
      );
      return currentCategory || activeArticleCategories?.[0];
    },
  },
  created() {
    this.setBreadcrumbs();
  },
  mounted() {
    this.visitEvent();
    window.scrollTo(0, 0);
  },
  methods: {
    setBreadcrumbs() {
      this.$store.commit("general/SET_BREADCRUMBS", [
        {
          text: this.$t("home"),
          disabled: false,
          href: this.localePath("/"),
        },
        {
          text: "Articles",
          disabled: false,
          href: this.localePath("/articles"),
        },
        {
          text:
            this.articleCategory?.mixedTranslation?.title ||
            this.$t("all"),
          disabled: !this.articleCategory?.slug,
          href: this.localePath(
            `/articles/${this.articleCategory?.slug || "all"}`
          ),
        },
        {
          text: this.article?.mixedTranslation?.title,
          disabled: true,
          href: this.localePath(
            `/articles/${this.articleCategory?.slug || "all"}/${this.article?.slug}`
          ),
        },
      ]);
    },
  },
};
